import axios from "axios";

const state={
    users:[]
};
const getters={
    allUsers: (state)=>state.users
};
const actions={

    
    async fetchUsers({commit},guid){
        axios.get(localConfig.authenticationURL + "/api/user/GetAllUsers/" + guid)
            .then(response => {
                console.log(response.data);
                commit("setUsers", response.data);
            })
            .catch(error => {
                localStorage.removeItem("token");
                console.log(error);
                reject(error);
                store.dispatch("login");
            });        
    },
    async updateUsers({commit}) {
        state.users.forEach((user)=>{
            if(user.changed){
                axios.put(localConfig.authenticationURL + "/api/user",user)
                    .then(response => {                    
                        console.log("saved: " + response.data);             
                    })
                    .catch(error => {
                        localStorage.removeItem("token");                    
                        console.log(error);
                        reject(error);
                        store.dispatch("login");
                    }); 
                user.changed=false;
            }       
        });
        window.Bus.$emit("UserUpdated", "UserUpdated");    
    },
    async addUser({commit},user) {        
        axios.post(localConfig.authenticationURL + "/api/user", user)
            .then(response => {
                console.log("saved: " + response.data);  
                window.Bus.$emit("UserAdded", "UserAdded");                
            })
            .catch(error => {
                console.log(error);
                reject(error);
                store.dispatch("login");
            }); 
        user.changed=false;                      
    },
    async deleteUser({commit},guid) {      
        axios.delete(localConfig.authenticationURL + "/api/user/" + guid)
            .then(response => {                
                console.log("deleted: " + response.data);  
                window.Bus.$emit("UserDeleted", "UserDeleted");                 
            })
            
            .catch(error => {          
                console.log(error);                
            });                    
    },
    async unlockUser({commit},guid) {      
        axios.post(localConfig.authenticationURL + "/api/user/unlockUser/" + guid)
            .then(response => {                
                console.log("User Unlocked: " + response.data);  
                window.Bus.$emit("UserUnlocked", "UserUnlocked");                 
            })
            
            .catch(error => {          
                console.log(error);                
            });                    
    }
};
const mutations={
    setUsers: (state, users)=>(state.users = users),
    updateUser:(state, updatedUser) =>{


    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

